// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"9928f5a0","283":"a23b2bed","342":"72768d67","500":"07b897fe","885":"744f6330","967":"07b897fe"}[chunkId] + ".chunk.css";
};